import React, { useRef, useState } from 'react';
import { api, fileUrl } from '@/lib/api';
import { Upload, X } from 'lucide-react';

export default function ImageUploader({ value, onChange, label = 'Image', testid = 'image-upload' }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const upload = async (file) => {
    if (!file) return;
    setErr(''); setBusy(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const r = await api.post('/admin/uploads', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(r.data.url);
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Upload failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      {label && <label className="block font-body text-[12px] font-semibold uppercase text-ink-muted tracking-wider2 mb-2">{label}</label>}
      <div className="flex items-start gap-4">
        <div className="w-40 h-28 border border-border-line rounded-sm bg-bg-canvas overflow-hidden flex items-center justify-center">
          {value ? (
            <img src={fileUrl(value)} alt="preview" className="w-full h-full object-cover" />
          ) : (
            <span className="font-body text-[10px] uppercase text-ink-soft tracking-wider3">No image</span>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => upload(e.target.files?.[0])}
            data-testid={testid}
          />
          <button type="button" onClick={() => inputRef.current?.click()} className="btn-secondary !py-2 !px-3 text-[11px]" disabled={busy}>
            <Upload size={14} className="mr-1" /> {busy ? 'Uploading…' : 'Upload Image'}
          </button>
          {value && (
            <button type="button" onClick={() => onChange('')} className="btn-secondary !py-2 !px-3 text-[11px]">
              <X size={14} className="mr-1" /> Remove
            </button>
          )}
          <input
            type="text"
            placeholder="Or paste image URL"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="border border-border-line rounded-sm px-2 py-1.5 font-body text-[12px] bg-white w-72"
          />
          {err && <div className="font-body text-[11px] text-brand-red">{err}</div>}
        </div>
      </div>
    </div>
  );
}
